var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useEntity } from '../hooks/use-entity';
import { EntityTab } from './entity-tab';
import { TabsContainer } from '../elements/tabs-container';
import { TabDefaultProps } from '../elements/tab';
var cls = classNames('page-family-tabs');
export var PageFamilyTabsDefaultProps = __assign(__assign({}, TabDefaultProps), {
  fill: true
});
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var lineColor = _a.lineColor,
      lineWidth = _a.lineWidth,
      lineVariant = _a.lineVariant;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-right: ", "px ", " ", ";\n    "], ["\n      border-right: ", "px ", " ", ";\n    "])), lineWidth, lineVariant, theme.COLOR(lineColor));
  })
});
var TabStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    &:last-child {\n      border-right: none;\n    }\n  "], ["\n    &:last-child {\n      border-right: none;\n    }\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled(TabsContainer)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Tab: styled(EntityTab)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), TabStyles)
};
export var PageFamilyTabs = function (props) {
  var className = props.className,
    children = props.children,
    lineColor = props.lineColor,
    lineWidth = props.lineWidth,
    lineVariant = props.lineVariant,
    labelPath = props.labelPath,
    fill = props.fill,
    tabComponent = props.tabComponent;
  var entity = useEntity(props.entity);
  var _a = entity.family,
    family = _a === void 0 ? [] : _a;
  if (!family.length) {
    return null;
  }
  var tabStyle = fill ? {
    flexBasis: "calc(".concat(1 / family.length * 100, "%)")
  } : {};
  return React.createElement(My.Container, {
    lineVariant: lineVariant,
    lineColor: lineColor,
    lineWidth: lineWidth,
    className: cls.name(className)
  }, family.map(function (page) {
    return React.createElement(My.Tab, {
      style: tabStyle,
      key: page.id,
      entity: page,
      labelPath: labelPath,
      tabComponent: tabComponent
    });
  }));
};
PageFamilyTabs.defaultProps = PageFamilyTabsDefaultProps;
PageFamilyTabs.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;